import React from "react";
import qs from "query-string";
import { useMutation } from "react-query";
import { useHistory } from "react-router";

import "./mobile-operators.css";

import SelectDropdown from "app/components/select-dropdown/SelectDropdown";
import { useGet } from "app/services/http-service";
import { GET_CIRCLE_BY_OPERATOR } from "app/api/ApiEndpoints";
import Loader from "app/loader/Loader";
import useAlertConfig from "app/hooks/useAlertConfig";
import Alert from "../alert/Alert";
import { isBBPSMobilePrepaidBiller } from "app/utils/MobileRechargeUtil";


function MobileOperators(props) {
  const { alertConfig, showFailureAlert } = useAlertConfig(6);
  const {
    changeStep,
    mobileNumber,
    operatorListData,
    circleOperatorByNumberData,
    errorCircleOperator,
  } = props;
  const history = useHistory();
  const authToken = localStorage.getItem("tspAuthToken");
  const [circles, setCircles] = React.useState({});
  const [operators, setOperators] = React.useState({});
  const [currentCircle, setCurrentCircle] = React.useState({});
  const [currentOperator, setCurrentOperator] = React.useState({});
  const [isHideOperator, setIsHideOperator] = React.useState(false);
  const [circleAndOperators, setCircleAndOperators] = React.useState(
    circleOperatorByNumberData,
  );
  const {
    mutate: circleByOperatorMutation,
    data: circleByOperatorData,
    isLoading: circleByOperatorDataLoading,
  } = useMutation((data) => useGet(data), {
    onError: (error) => {
      showFailureAlert(error.message ? error.message : "Something went wrong!");
    }
  });

  React.useEffect(() => {
    setCircleAndOperators(circleOperatorByNumberData);
    if (
      circleOperatorByNumberData &&
      circleOperatorByNumberData.status !== "FAILURE"
    ) {
      if (operatorListData && operatorListData.content) {
        const operators = operatorListData?.content.map((o) => ({
          value: o.operatorCode,
          label: o.operatorName,
        }));
        setOperators(operators);
        const currentOperator = operators.find(
          (op) => op.value == circleOperatorByNumberData.payload.operatorCode,
        );
        setCurrentOperator(currentOperator);
      }
    }
  }, [circleOperatorByNumberData, operatorListData]);

  React.useEffect(() => {
    if (circleByOperatorData && circleByOperatorData.content) {
      const circles = circleByOperatorData?.content.map((o) => ({
        value: o.circleId,
        label: o.circleName,
      }));
      setCircles(circles);
      if (circleOperatorByNumberData){
        const currentCircle = circles.find(
          (c) => c.value == circleOperatorByNumberData.payload.circleRefID,
        );
        setCurrentCircle(currentCircle);
      }
    }
  }, [circleByOperatorData]);

  React.useEffect(() => {
    const queryParams = {
      operatorId: currentOperator?.value,
      operatorName: currentOperator?.label,
      page: 0,
      size: 100,
      sortAscending: true,
      sortingField: "circleName",
    };
    const body = {
      url: `${GET_CIRCLE_BY_OPERATOR}?${qs.stringify(queryParams)}`,
      token: authToken,
    };
    circleByOperatorMutation(body);
  }, [currentOperator]);

  return (
    <div className="col-md-8 p-0">
      {alertConfig && (
        <Alert alertMessage={alertConfig.message} status={alertConfig.status} />
      )}
      <div className="d-flex justify-content-space-bwn c-list pt-0">
        <div>
          <h3 className="font_600">{mobileNumber}</h3>
        </div>
        <div>
          <i className="material-icons" onClick={() => { history.push(`/recharge/MOBILE%20PREPAID?phoneNumber=${mobileNumber}`); }}>
            edit
          </i>
        </div>
        {circleOperatorByNumberData?.payload?.operatorCode &&
          circleOperatorByNumberData?.payload?.circleRefID && (
            <div
              className="text-success cursor-pointer"
              onClick={() => {
                changeStep(3);
                history.push(
                  `/recharge/${circleAndOperators?.payload?.operatorCode}/${circleAndOperators?.payload?.circleRefID}/plan?mobileNumber=${mobileNumber}`,
                );
              }}
            >
              Proceed
              <i className="material-icons">keyboard_arrow_right</i>
            </div>
          )}
      </div>
      {!errorCircleOperator && !circleAndOperators && <Loader loaderMessage="Loading..." />}
      
      {!errorCircleOperator && circleAndOperators && circleAndOperators.status !== "FAILURE" && (
        <div className="row mt-4">
          <div className="col-md-6">
            <SelectDropdown
              dropdownOptions={operators}
              defaultSelected={currentOperator}
              onChange={(value) => {
                setCurrentOperator(value);
                setCircleAndOperators((oldValue) => {
                  oldValue.payload.operatorCode = value.value;
                  return oldValue;
                });
              }}
            />
          </div>
          <div className="col-md-6">
            <SelectDropdown
              dropdownOptions={circles}
              defaultSelected={currentCircle}
              onChange={(value) => {
                setCurrentCircle(value);
                setCircleAndOperators((oldValue) => {
                  oldValue.payload.circleRefID = value.value;
                  return oldValue;
                });
              }}
            />
          </div>
        </div>
      )}
      {(errorCircleOperator || (circleAndOperators && circleAndOperators.status === "FAILURE")) && 
        (
        <>
          {!isHideOperator && (
            <h6 className="font_600 my-2 ml-4">Select Your Operator</h6>
          )}
          {!isHideOperator && !operatorListData && (
            <Loader loaderMessage="Loading..." />
          )}

          {!isHideOperator &&
            operatorListData &&
            operatorListData?.content?.length === 0 && (
              <p className="text-center my-2">No Operator Found</p>
            )}
          {!isHideOperator &&
            operatorListData &&
            operatorListData?.content?.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  setCurrentOperator({
                    value: item.operatorCode,
                    label: item.operatorName,
                  });
                  setIsHideOperator(true);
                }}
              >
                <div className="c-list mobile-operator cursor-pointer">
                  <div className="name-circle">
                    <img
                      src={`/img/operator/${item.operatorCode}.png`}
                      alt={item.operatorName}
                      width="100%"
                      height="45px"
                    />
                  </div>
                  <div className="name">
                    <h6>{item.operatorName}</h6>
                  </div>
                </div>
              </div>
            ))}
          {isHideOperator && (
            <h3 className="font_600 my-2">Select Your Circle</h3>
          )}
          {isHideOperator && circleByOperatorDataLoading && (
            <Loader loaderMessage="Loading..." />
          )}
          {isHideOperator &&
            circleByOperatorData &&
            circleByOperatorData?.content?.length === 0 && (
              <p className="text-center my-2">No Circle Found</p>
            )}
          {isHideOperator &&
            circleByOperatorData &&
            circleByOperatorData?.content?.map((item, index) => {
              let currentCircleId ={};
              if(isBBPSMobilePrepaidBiller(currentOperator?.value)){
                currentCircleId=item?.circleName;
              }else{
                currentCircleId=item?.circleId;
              }
              return (
                <div
                  key={index}
                  onClick={() => {
                    setCurrentCircle({
                      circleId: item.circleId,
                      circleName: item.circleName,
                    });
                    changeStep(3);
                    history.push(
                      `/recharge/${currentOperator?.value}/${currentCircleId}/plan?mobileNumber=${mobileNumber}`,
                    );
                  }}
                >
                  <div className="c-list state-circle cursor-pointer">
                    <div className="name">
                      <h3>{item.circleName}</h3>
                    </div>
                  </div>
                </div>
              );
            })}
        </>
      )}
    </div>
  );
}

export default MobileOperators;
